import Modal from '../../../Modal/index';
import {
  Container,
  Title,
  Footer,
  DivIcon,
  Content,
  SubTitle,
  Info,
  Description,
} from './styles';
import Button from '../../../Button';
import Close from '../../../../../assets/icons/Close';
import { usePromiseTracker } from 'react-promise-tracker';
import ReactLoading from 'react-loading';

export const ConfirmActiveModal = ({
  onConfirm = () => console.log('activate'),
  name,
  client,
  description,
  flow,
  isOpen,
  onClose,
  selector = '#root',
  className = null,
}) => {
  const { promiseInProgress: loading } = usePromiseTracker({ area: 'activate-flow' });



  return (
    <Modal
      isOpen={isOpen}
      onClose={!loading ? onClose : null}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Ativação de Fluxo</Title>
        <SubTitle status={loading}>
          {!loading ?
            "Deseja seguir com a ativação do fluxo?"
            :
            "O Fluxo está sendo criado, aguarde..."
          }</SubTitle>
        {!loading ? (
          <>
            <Content>
              <Info>
                <span>Nome do Fluxo: </span>
                <div>
                  <p>{name}</p>
                </div>
              </Info>
              <Info>
                <span>Nome do Cliente: </span>
                <div>
                  <p>{client}</p>
                </div>
              </Info>
              <Info>
                <span>Fluxo Modelo: </span>
                <div style={{ border: 'none' }}>
                  <p>
                    {' '}
                    -{'>'} {flow.title}
                  </p>
                </div>
              </Info>
              <Description>
                <span>Descrição </span>
                <div>
                  <p>{description}</p>
                </div>
              </Description>
            </Content>
            <Footer>
              <Button
                outline
                content="Cancelar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onClose}
              />
              <Button
                greenBase
                content="Confirmar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onConfirm}
              />
            </Footer>
            <DivIcon>
              <Close onClick={onClose} />
            </DivIcon>
          </>
        ) : (
          <div
            style={{
              padding: '4rem',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '1rem',
            }}
          >

            <ReactLoading type="bars" color="#118052" />
          </div>
        )}
      </Container>
    </Modal>
  );
};
